// API service for GlobalSearch
import { get } from '../../../utils/api';

export const fetchSearchedRecords = async (
  organizationId,
  propertyId,
  searchTerm,
) => {
  try {
    const queryParams = new URLSearchParams({
      match: searchTerm,
      ...(propertyId && { propertyId }),
    });

    const response = await get(`/${organizationId}/full-search?${queryParams}`);
    return response;
  } catch (error) {
    console.error('Failed to fetch recent searches:', error);
    throw new Error('Failed to fetch recent searches');
  }
};

export const fetchRecentSearches = async () => {
  try {
    const response = await get('/user-recent-searches');
    return response;
  } catch (error) {
    console.error('Failed to fetch recent searches:', error);
    throw new Error('Failed to fetch recent searches');
  }
};
